// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"91f159ec","96":"34b6420f","233":"17341563","453":"aefd2f63","469":"1b32a331","532":"46d9bde2","731":"a55a0972"}[chunkId] + ".chunk.js";
};